import React from "react";
import styled from "styled-components";

const Container = styled.div`
  margin-right: 50px;
  margin-bottom: 20px;
  .title {
    font-weight: bold;
    font-size: 12px;
    line-height: 14px;
    color: #333333;
    display: block;
    margin-bottom: 5px;
  }
  .indicator_list {
    display: flex;
    direction: row;
  }
  .indicator {
    display: flex;
    align-items: center;
    justify-content: left;
    margin-right: 20px;
    > span {
      font-weight: normal;
      font-size: 13px;
      line-height: 15px;
      color: #333333;
      margin-left: 5px;
    }
  }
`;

const Dot = styled.div`
  display: block;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: ${(props) => props.color};
`;

function StatusIndicator(props) {
  const { title, indicators } = props;
  return (
    <Container>
      <span className="title">{title}</span>
      <div className="indicator_list">
        {indicators.map(({ color, label }) => (
          <div className="indicator">
            <Dot color={color} />
            <span>{label}</span>
          </div>
        ))}
      </div>
    </Container>
  );
}

export default StatusIndicator;
